// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.checkbox[data-v-616b1fc5]{display:block}.ui.checkbox[data-v-616b1fc5]:not(:last-child){margin-bottom:10px}.ui.list[data-v-616b1fc5]{margin-left:2.5rem;margin-top:.5rem}.select-all-checkbox[data-v-616b1fc5]{margin-top:10px;margin-bottom:10px}label[data-v-616b1fc5]{line-height:20px;display:block}", ""]);
// Exports
module.exports = exports;
